module.exports = __webpack_public_path__ + "img/create-sense4.67c3f204.png";